import { buildApiUrl } from 'fake-db/apiConfig'
import Mock from '../../mock'
import axios from 'axios.js'

const normalizeOutletsList = (responseData) => {
    if (Array.isArray(responseData)) return responseData;
    if (Array.isArray(responseData?.data)) return responseData.data;
    return null;
};


const getAllOutletsUser = async ()=>{
    const response = await axios.get(buildApiUrl('outlets/getAllOutlets/'));

    const AllOutletsUser = normalizeOutletsList(response.data);

    //console.log('Сервер вернул данные по Outlets ---- ',response.data);


    return AllOutletsUser;
};


const setActiveOutlets = async (id,val)=>{
    const response = await axios.post(buildApiUrl('outlets/setOutletsActive/'),{
        id,
        val
    });

    const AllOutletsUser = normalizeOutletsList(response.data);

    // console.log('Сервер вернул данные по обновлению статуса Outlets  - ',response);


    return AllOutletsUser;
};



const setDeletedOutlets = async (id,val)=>{
    const response = await axios.post(buildApiUrl('outlets/setOutletsDeleted/'),{
        id,
        val
    });

    const AllOutletsUser = normalizeOutletsList(response.data);

    // console.log('Сервер вернул данные по обновлению статуса Outlets  - ',response);


    return AllOutletsUser;
};




const setUpdateOutlets = async (dataOutletsUpdate)=>{
    const response = await axios.post(buildApiUrl('outlets/setOutletsUpdate/'),{
        dataOutletsUpdate
    });

    const AllOutletsUser = normalizeOutletsList(response.data);

    //console.log('Сервер вернул данные по обновлению статуса Outlets  - ',dataOutletsUpdate,response);


    return AllOutletsUser;
};


const setSaveNewOutlets = async (dataOutletsUpdate)=>{
    const response = await axios.post(buildApiUrl('outlets/setSaveNewOutlets/'),{
        dataOutletsUpdate
    });
    const AllOutletsUser = normalizeOutletsList(response.data);

    //console.log('Сервер вернул данные по обновлению статуса Outlets  - ',response, dataOutletsUpdate);


    return AllOutletsUser;
};

Mock.onGet('/api/outlets/getAllOutlets').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    const AllOutletsUser = await getAllOutletsUser();
    // console.log('С сервера пришло - ', AllOutletsUser);

    // if (!AllOutletsUser) {
    //     return [400, { message: 'Список цветов отсутствует!' }]
    // }


    if (!AllOutletsUser) {
        return [200, [] ]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        AllOutletsUser,
    ]


})


Mock.onPost('/api/outlets/setActiveOutlets').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { id } = JSON.parse(config.data);
    let { val } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ',id, val, config.data);

    const AllOutletsUser = await setActiveOutlets(id,val);

    // if (!AllOutletsUser) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }


    if (!AllOutletsUser) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        AllOutletsUser,
    ]


})

Mock.onPost('/api/outlets/setDeletedOutlets').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { id } = JSON.parse(config.data);
    let { val } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ',id, val, config.data);

    const AllOutletsUser = await setDeletedOutlets(id,val);

    // if (!AllOutletsUser) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }


    if (!AllOutletsUser) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        AllOutletsUser,
    ]


})


Mock.onPost('/api/outlets/setUpdateOutlets').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { dataOutletsUpdate } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ', config.data);

    const Outlets = await setUpdateOutlets(dataOutletsUpdate);

    // console.log('Серовер вернул данные ',AllOutletsUser);

    // if (!Outlets) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }

    if (!Outlets) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        Outlets,
    ]


})


Mock.onPost('/api/outlets/setSaveNewOutlets').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { dataOutletsUpdate } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ', config.data);

    const Outlets = await setSaveNewOutlets(dataOutletsUpdate);

    // console.log('Серовер вернул данные ',AllOutletsUser);

    // if (!Outlets) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }

    if (!Outlets) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        Outlets,
    ]
})
